import { useQueryClient } from "@tanstack/react-query"
import { useServerFn } from "@tanstack/react-start"

import { logout as logoutAction } from "../rpc/logout"

export function useLogout() {
  const queryClient = useQueryClient()
  const logoutFn = useServerFn(logoutAction)

  return async function logout() {
    await logoutFn()
    // The redirect is client-side, so this QueryClient survives: reset every query (trips, expenses, ...) so the
    // next user in this tab never sees cached data. Unlike clear(), reset keeps mounted observers attached and
    // refetches the active ones (e.g. the user query behind the header).
    await queryClient.resetQueries()
  }
}
